import React from 'react';
import Image from 'next/image';
import { useCreateAccountProvider } from '@/lib/context';
import { BANNER_VALUE_PROPS, WORK_WITH_FACTORIES_DESCRIPTION } from '@/shared/constants/sourcing-marketplace';
import { SourcingMarketplaceBannerValueProp } from '@/shared/types/sourcing-marketplace';
import './index.less';

interface IProps {
  signupRedirect: string;
  utmMedium: string;
}

const ExplorePietraServicesBanner = ({ signupRedirect, utmMedium }: IProps) => {
  const { showSignupDialogFromSourcing } = useCreateAccountProvider();

  return (
    <div className="explore-pietra-services-banner">
      <div className="inner">
        <div className="header">
          <Image
            className="logos"
            width={145}
            height={26}
            src="/images/sourcing/banner/pietra-shopify-logos.svg"
            alt="Build a Shopify brand"
          />
          <h2 className="title">The preferred platform to build a Shopify brand</h2>
          <span
            className="sign-up-button"
            onClick={() => showSignupDialogFromSourcing(WORK_WITH_FACTORIES_DESCRIPTION, signupRedirect, utmMedium)}
          >
            Sign up for Pietra
          </span>
        </div>
        <div className="cards">
          {BANNER_VALUE_PROPS.map((valueProp: SourcingMarketplaceBannerValueProp, i: number) => (
            <div className={`card ${valueProp.classname}`} key={i}>
              <div className="title">
                <Image width={24} height={24} src={valueProp.icon} alt={valueProp.title} />
                <h3>{valueProp.title}</h3>
              </div>
              <span className="description">{valueProp.description}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExplorePietraServicesBanner;
